import * as tslib_1 from "tslib";
import * as React from 'react';
import { Card, CardHeader } from 'material-ui/Card';
import { Avatar } from 'material-ui';
import { avatar, monogram } from 'src/models/User';
import TaskCardBadges from '../tasks/TaskCardBadges';
import { observer, inject } from 'mobx-react';
import { RaisedButton } from 'material-ui';
var styles = {
    header: {
        textOverflow: 'ellipsis',
    },
    title: {
        textOverflow: 'ellipsis',
    },
    item: {
        margin: '1rem auto',
        padding: '0',
        color: '#414141',
        cursor: 'pointer',
        width: '25%',
    },
    text: {
        fontSize: '12px',
        paddingRight: 0,
        maxWidth: '300px',
    },
    headertext: {
        margin: '1rem auto',
        textAlign: 'center'
    },
    button: {
        margin: '1rem auto',
        width: '25%',
        textAlign: 'right'
    },
    finish: {
        color: '#FFFFFF',
        width: '150px',
        marginRight: '1rem'
    },
    action: {
        color: '#FFFFFF',
        width: '150px'
    }
};
var NfcTaskItem = /** @class */ (function (_super) {
    tslib_1.__extends(NfcTaskItem, _super);
    function NfcTaskItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnItemClick = function () {
            if (_this.props.onItemClicked) {
                _this.props.onItemClicked(_this.props.nfcTaskItem);
            }
        };
        _this.handleFinish = function () {
            if (_this.props.onItemFinished) {
                _this.props.onItemFinished(_this.props.nfcTaskItem);
            }
        };
        _this.handlePause = function () {
            if (_this.props.onItemPause) {
                _this.props.onItemPause(_this.props.nfcTaskItem);
            }
        };
        _this.handleStart = function () {
            if (_this.props.onItemStart) {
                _this.props.onItemStart(_this.props.nfcTaskItem);
            }
        };
        return _this;
    }
    NfcTaskItem.prototype.render = function () {
        var header = this.props.isRunning ? (React.createElement("div", { style: styles.headertext },
            React.createElement("span", null, "Folyamatban l\u00E9v\u0151 feladat"))) : null;
        var breakButton = this.props.nfcTaskItem.workerStatus === 2 ?
            (React.createElement(RaisedButton, { style: styles.action, className: "secondary", primary: false, onClick: this.handlePause }, "Sz\u00FCneteltet\u00E9s")) :
            null;
        var startButton = this.props.nfcTaskItem.workerStatus !== 2 ? (React.createElement(RaisedButton, { style: styles.action, className: "secondary", primary: false, onClick: this.handleStart }, "Elind\u00EDt\u00E1s")) : null;
        var actions = this.props.isRunning ? (React.createElement("div", { style: styles.button },
            React.createElement(RaisedButton, { style: styles.finish, className: "primary", primary: true, onClick: this.handleFinish }, "Feladat elv\u00E9gezve"),
            breakButton,
            startButton)) : null;
        var avatarElement = this.props.preferencesStore.cardAvatarVisible.value
            ? avatar(this.props.nfcTaskItem.userId)
            : React.createElement("span", { title: this.props.nfcTaskItem.userName },
                React.createElement(Avatar, null, monogram(this.props.nfcTaskItem.userName)));
        return (React.createElement(React.Fragment, null,
            header,
            React.createElement("div", { onClick: this.handleOnItemClick },
                React.createElement(Card, { style: styles.item },
                    React.createElement(CardHeader, { textStyle: styles.text, avatar: avatarElement, style: tslib_1.__assign({}, styles.header, { border: '1px solid' + this.props.color }), titleStyle: styles.title, title: this.props.nfcTaskItem.title, subtitle: this.props.nfcTaskItem.stepName },
                        React.createElement(TaskCardBadges, { task: this.props.nfcTaskItem })))),
            actions));
    };
    NfcTaskItem = tslib_1.__decorate([
        inject('preferencesStore'),
        observer
    ], NfcTaskItem);
    return NfcTaskItem;
}(React.Component));
export default NfcTaskItem;



//////////////////
// WEBPACK FOOTER
// ./src/pages/nfctask/NfcTaskItem.tsx
// module id = 807
// module chunks = 0